module.exports = __webpack_public_path__ + "files/SPIADI2022 - RÉA-SINK.4c1fcd917c6172803d7a56d4c8036be1.pdf";